var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "m-grid__item m-header",
      attrs: {
        "data-minimize-offset": "200",
        "data-minimize-mobile-offset": "200"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "m-container m-container--fluid m-container--full-height",
          attrs: { id: "navbar_element_id" }
        },
        [
          _c("div", { staticClass: "m-stack m-stack--ver m-stack--desktop" }, [
            _c(
              "div",
              { staticClass: "m-stack__item m-brand m-brand--skin-dark" },
              [
                _c(
                  "div",
                  { staticClass: "m-stack m-stack--ver m-stack--general" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "m-stack__item m-stack__item--middle m-brand__logo"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "m-brand__logo-wrapper",
                            attrs: { to: { name: "home" } }
                          },
                          [
                            _c("img", {
                              staticClass: "navbar-img",
                              attrs: { alt: "", src: "/media/img/logo.png" }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "m-stack__item m-stack__item--fluid m-header-head",
                attrs: { id: "m_header_nav" }
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "m-topbar m-stack m-stack--ver m-stack--general",
                    attrs: { id: "m_header_topbar" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "m-stack__item m-topbar__nav-wrapper" },
                      [
                        _c(
                          "ul",
                          { staticClass: "m-topbar__nav m-nav m-nav--inline" },
                          [
                            Object.keys(_vm.user_data).length > 0
                              ? _c("s-notification")
                              : _vm._e(),
                            _vm._v(" "),
                            _c("s-quick-actions"),
                            _vm._v(" "),
                            Object.keys(_vm.user_data).length > 0
                              ? _c("s-profile", {
                                  attrs: { user: _vm.user_data }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "m-stack__item m-stack__item--middle m-brand__tools" },
      [
        _c(
          "a",
          {
            staticClass:
              "m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block",
            attrs: { href: "javascript:;", id: "m_aside_left_minimize_toggle" }
          },
          [_c("span")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block",
            attrs: { href: "javascript:;", id: "m_aside_left_offcanvas_toggle" }
          },
          [_c("span")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "m-brand__icon m--visible-tablet-and-mobile-inline-block",
            attrs: {
              id: "m_aside_header_topbar_mobile_toggle",
              href: "javascript:;"
            }
          },
          [_c("i", { staticClass: "flaticon-more" })]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "m-aside-header-menu-mobile-close m-aside-header-menu-mobile-close--skin-dark",
        attrs: { id: "m_aside_header_menu_mobile_close_btn" }
      },
      [_c("i", { staticClass: "la la-close" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas m-header-menu--skin-light m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark",
        attrs: { id: "m_header_menu" }
      },
      [_c("ul", { staticClass: "m-menu__nav m-menu__nav--submenu-arrow" })]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fba48f3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fba48f3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/navbar/Base.vue
// module id = 781
// module chunks = 0 54 132